import * as jspb from 'google-protobuf';

import {ApiTransportOptions} from '@/services/api-transport/transport-service';

export abstract class RequestsService {
    abstract getRequest(idToken: string, options: ApiTransportOptions): Promise<jspb.Message | null>;
}
